import { useContext } from 'react'
import { ThemeContext, type ThemeContextType } from '@/contexts/ThemeContext'

export function useTheme(): ThemeContextType {
  const context = useContext(ThemeContext)
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider')
  }
  return context
}

// Re-export types and themes for convenience
export type { ThemeName, Theme, ThemeContextType } from '@/contexts/ThemeContext'
export { themes } from '@/contexts/ThemeContext'
